import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ContentType, DataPrivacyPolicy } from './data-privacy.interface';
import { Location } from '@angular/common';
import { pathToPrivacyPolicyVersion } from '../../../../constants/app.constants';
import { RoutesEnum } from '../../../../enums/routes.enum';
import { CardComponent } from '../../../atoms/card/card/card.component';
import { IconComponent } from '../../../atoms/icon/icon.component';
import { SectionComponent } from '../../../molecules/content/section/section.component';

@Component({
  selector: 'app-data-privacy',
  imports: [SectionComponent, CardComponent, IconComponent],
  templateUrl: './data-privacy.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './data-privacy.component.scss',
})
export class DataPrivacyComponent implements OnInit {
  protected RoutesEnum = RoutesEnum;
  protected ContentType = ContentType;

  readonly http = inject(HttpClient);
  readonly location = inject(Location);

  readonly content = signal<DataPrivacyPolicy | null>(null);

  ngOnInit(): void {
    this.http.get<DataPrivacyPolicy>(pathToPrivacyPolicyVersion).subscribe((response) => {
      this.content.set(response);
    });
  }

  public goBack(): void {
    this.location.back();
  }
}
